import './LegalPages.css'

export function TermsAndConditions() {
  return (
    <main className="legal-page">
      <article className="legal-content">
        <header className="legal-header">
          <h1>Clnicl Terms and Conditions</h1>
          <p className="legal-meta">Version 1.0 | Effective date: 2026-02-23</p>
        </header>

        <p className="legal-warning">
          Draft for solicitor review. This text is an operational first pass and must be reviewed by legal
          counsel before production release.
        </p>

        <section className="legal-section">
          <h2>1. Parties and Scope</h2>
          <p>
            These terms apply to the contracting customer entity (the practice or clinic) and govern use of
            Clnicl services, including Clnicl PMS and PCRS Power Tool (PPT). By using the service, the
            customer confirms that it has authority to bind the practice or clinic.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Customer Operational Responsibility</h2>
          <p>
            The customer remains solely responsible for all clinical, coding, billing, reimbursement, and
            administrative decisions made through the platform. Clnicl provides software tooling only.
          </p>
          <ul>
            <li>Maintaining data accuracy and completeness</li>
            <li>Validating claim eligibility and submission content</li>
            <li>Ensuring authorised staff access and internal controls</li>
            <li>Complying with all applicable health, data protection, and reimbursement rules</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. PCRS Responsibility and Liability Allocation</h2>
          <p>
            The customer acknowledges and agrees that it is fully and exclusively responsible and liable for
            all PCRS-related activity carried out by or on behalf of the practice or clinic, including
            submissions, amendments, reversals, declarations, and supporting evidence.
          </p>
          <p>
            To the maximum extent permitted by law, Clnicl is excluded from liability for PCRS outcomes,
            reimbursement decisions, audits, rejections, overpayments, clawbacks, penalties, or related
            consequential costs arising from customer activity.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Indemnity</h2>
          <p>
            The customer agrees to indemnify and hold harmless Clnicl, its directors, officers, employees,
            and contractors from and against claims, losses, liabilities, costs, and expenses (including
            reasonable legal fees) arising from or related to customer use of the platform, including
            PCRS-related actions and omissions.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Limitation of Liability</h2>
          <p>
            Subject to mandatory legal protections that cannot be excluded, Clnicl disclaims liability for
            indirect, consequential, incidental, special, or punitive losses. Any aggregate direct liability
            cap and exclusions are subject to solicitor confirmation in final contract form.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Data Protection</h2>
          <p>
            Processing of personal data is subject to the Privacy Notice and, where applicable, a separate
            data processing arrangement. The customer is responsible for determining lawful basis and
            disclosure obligations to patients and staff.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Updates</h2>
          <p>
            Clnicl may update these terms from time to time. Updated versions will be published and may
            require renewed acceptance before continued onboarding or service use.
          </p>
        </section>

        <nav className="legal-nav" aria-label="Legal navigation">
          <a href="/privacy-notice">Privacy Notice</a>
          <a href="/pcrs-responsibility">PCRS Responsibility Statement</a>
          <a href="/register">Back to registration</a>
        </nav>
      </article>
    </main>
  )
}
